const $inject = [];

const seatNumberService = function () {
  const service = {};

  service.activeSeat = null;
  service.set = set;

  return service;

  function set(seat) {
    service.activeSeat = seat;
  }
};

seatNumberService.$inject = $inject;

export default seatNumberService;



// WEBPACK FOOTER //
// ./src/services/seatNumberService.js